<template>
  <div @click="showModal">
    <slot name="button"></slot>
    <teleport to="body">
      <div
        class="hidden"
        :ref="`modalHtml${id}`"
      >
        <slot name="modalHtml"></slot>
      </div>
    </teleport>
  </div>
</template>

<script>

export default {
  name: "adivare-sweet-alert-modal",
  props: {
    modalTitle: {
      type: String,
      required: false,
      default: null,
    },
    modalIcon: {
      type: String,
      required: false,
      default: null,
    },
    id: {
      type: String,
      required: false,
      default: '',
    },
    showCloseButton: {
      type: Boolean,
      required: false,
      default: true,
    },
    showConfirmButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    showCancelButton: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      config: {},
    };
  },
  methods: {
    showModal(id) {
      this.config = {
        icon: this.modalIcon,
        title: this.modalTitle,
        showCloseButton: this.showCloseButton,
        showConfirmButton: this.showConfirmButton,
        showCancelButton: this.showCancelButton,
      }

      const html = this.$refs['modalHtml' + this.id].innerHTML || false;
      if (html) this.config['html'] = html;

      this.$swal(this.config);
    }
  }
}
</script>
